export default __webpack_public_path__ + "static/media/man.200268ae.png";